import e from"./Menu.vue_vue&type=script&lang.js";import{render as t}from"./Menu.vue_vue&type=template&id=9bcc0be2&lang.js";e.render=t,e.__file="src/components/Menu.vue";export default e;
//# sourceMappingURL=Menu.vue.js.map
